<template>
  <div class="map-kit-basemap-selector">
    <div
      v-for="bm in basemaps"
      :key="bm.id"
      class="map-kit-basemap-option"
      :class="{ 'map-kit-basemap-option--active': activeBasemapId === bm.id }"
      @click="setBasemap(bm.id)"
    >
      <RadioButton
        :model-value="activeBasemapId"
        :value="bm.id"
        :input-id="`bm-${bm.id}`"
        name="basemap"
        @update:model-value="setBasemap($event)"
      />
      <label :for="`bm-${bm.id}`" class="map-kit-basemap-label">{{ bm.name }}</label>
    </div>
  </div>
</template>

<script setup lang="ts">
import RadioButton from 'primevue/radiobutton';

import { useMap } from '@/composables/useMap';

const { basemaps, activeBasemapId, setBasemap } = useMap();
</script>
